import { createRoute } from "@tanstack/react-router";
import { workspaceRoute } from "../shell/routes";
import { TaskPage } from "./TaskPage";
import { TasksPage } from "./TasksPage";

const tasksLayoutRoute = createRoute({ getParentRoute: () => workspaceRoute, path: "tasks" });

/** Tasks (WP-012, WP-053): mine / assigned by me / private / shared / all, open, done or cancelled. */
const tasksIndexRoute = createRoute({
  getParentRoute: () => tasksLayoutRoute,
  path: "/",
  component: function Tasks() {
    const { workspaceId } = tasksIndexRoute.useParams();
    return <TasksPage key={workspaceId} workspaceId={workspaceId} />;
  },
});

/** One task as its own page (WP-053), edited in place and saved as it changes. */
const taskRoute = createRoute({
  getParentRoute: () => tasksLayoutRoute,
  path: "$taskId",
  component: function Task() {
    const { workspaceId, taskId } = taskRoute.useParams();
    return <TaskPage key={`${workspaceId}/${taskId}`} workspaceId={workspaceId} taskId={taskId} />;
  },
});

export const tasksRoute = tasksLayoutRoute.addChildren([tasksIndexRoute, taskRoute]);
